module.exports = __webpack_public_path__ + "static/media/search_client.840ce377.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/search_client.md
// module id = 1115
// module chunks = 0